import { render, staticRenderFns } from "./TrafficSites.vue?vue&type=template&id=bf9314fc&scoped=true"
import script from "./TrafficSites.vue?vue&type=script&lang=js"
export * from "./TrafficSites.vue?vue&type=script&lang=js"
import style0 from "./TrafficSites.vue?vue&type=style&index=0&id=bf9314fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9314fc",
  null
  
)

export default component.exports